import { colors, textColors, linearGroups } from '../style/colors'
import { camelToKebab } from './helpers'

type ColorsKeys = keyof typeof colors
type TextColorsKeys = keyof typeof textColors
type LinearGroupKeys = keyof typeof linearGroups
type LinearGroupPositions = 'start' | 'end'

function cssVarColor(): Record<ColorsKeys, string> {
  const obj = { ...colors }
  Object.keys(colors).forEach(key => {
    obj[key as ColorsKeys] = `var(--${camelToKebab(key)})`
  })
  return obj
}

export const cssVarColors = cssVarColor()

function cssVarTextColor(): Record<TextColorsKeys, string> {
  const obj = { ...textColors }
  Object.keys(textColors).forEach(key => {
    obj[key as TextColorsKeys] = `var(--text-${camelToKebab(key)})`
  })
  return obj
}

export const cssVarTextColors = cssVarTextColor()

function cssVarLinear(): Record<LinearGroupKeys, string[]> {
  const obj = { ...linearGroups }
  Object.keys(linearGroups).forEach(key => {
    obj[key as LinearGroupKeys] = [
      `var(--${camelToKebab(key)}-start)`,
      `var(--${camelToKebab(key)}-end)`
    ]
  })
  return obj
}

export const cssVarLinears = cssVarLinear()
